var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeImg === 'file')?_c('img',{attrs:{"src":("/img/" + _vm.srcImage),"alt":_vm.alt}}):_c('img',{attrs:{"src":_vm.srcImage,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }